import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	adminWallet: null,
	walletDetails: null,
	loading: false,
	addFundsModal: false,
	paymentAccount: null,
	withdrawFundsModal: false,
	deductWalletMessage: null,
	moveFundsMessage: null,
	availableBanks: null,
	activateWalletModal: false,
};

export const WalletSlice = createSlice({
	name: "wallet",
	initialState,
	reducers: {
		saveWalletInfo: (state, action) => {
			state.adminWallet = action.payload.wallet;
			state.walletDetails = action.payload.otherWalletDetails;
		},
		setLoadingState: (state, action) => {
			state.loading = action.payload;
		},
		toggleAddFundsModal: (state, action) => {
			state.addFundsModal = action.payload;
		},
		savePaymentDetails: (state, action) => {
			state.paymentAccount = action.payload;
		},
		toggleWithdrawFundsModal: (state, action) => {
			state.withdrawFundsModal = action.payload;
		},
		deductFromWalletSuccess: (state, action) => {
			(state.adminWallet = action.payload.wallet), (state.deductWalletMessage = action.payload.message);
		},
		moveFundsSuccess: (state, action) => {
			(state.adminWallet = action.payload.wallet), (state.moveFundsMessage = action.payload.message);
		},
		clearDeductWalletSuccess: (state) => {
			state.deductWalletMessage = null;
		},
		clearMoveFundsSuccess: (state) => {
			state.moveFundsMessage = null;
		},
		saveAvailableBanks: (state, action) => {
			state.availableBanks = action.payload;
		},
		toggleActivateWalletModal: (state, action) => {
			state.activateWalletModal = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	toggleAddFundsModal,
	saveWalletInfo,
	setLoadingState,
	savePaymentDetails,
	toggleWithdrawFundsModal,
	deductFromWalletSuccess,
	moveFundsSuccess,
	clearDeductWalletSuccess,
	clearMoveFundsSuccess,
	saveAvailableBanks,
	toggleActivateWalletModal,
} = WalletSlice.actions;

export default WalletSlice.reducer;
